import React from 'react';
import { useNotification } from '../context/NotificationContext';
import './Notification.css';

export default function NotificationContainer() {
  const { notifications, dismiss } = useNotification();

  return (
    <div className="notif-container">
      {notifications.map((n) => (
        <div key={n.id} className={`notif notif-${n.type}`} style={{ '--notif-duration': `${n.duration}ms` }}>
          <div className="notif-body">
            <span className="notif-msg">{n.message}</span>
            <button className="notif-close" onClick={() => dismiss(n.id)} aria-label="Close">&times;</button>
          </div>
          <div className="notif-timer" />
        </div>
      ))}
    </div>
  );
}
